<template>
    <div class="box-checkbox">
        <div class="d-flex" @click="toggelCheck()">
            <div class="icon-check">
                <img v-if="content" src="@/assets/icon/checkbox_active.svg">
                <img v-else src="@/assets/icon/checkbox_inactive.svg">
            </div>
            <div class="text-label-check">
                {{textLabel}}
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: "CheckBox",
    props: {
        textLabel: String,
        setValue: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data: function() {
        return {
            content: false,
        };
    },
    created: function() {
        this.content = this.setValue;
    },
    methods: {
        toggelCheck: function() {
            this.content = !this.content;

            this.$emit('input', this.content);
        },
    },
}
</script>
<style lang="scss" scoped>
    @import "@/style/base/baseUtility.scss";
    .box-checkbox {
        @extend %unselectable;
        cursor: pointer;
        padding: 10px 0px;

        .icon-check {
            width: 20px;

            img {
                width: 100%;
            }
        }
        .text-label-check {
            font-size: 1rem;
            font-weight: bold;
            margin: {
                top: 2px;
                left: 10px;
            };
        }
    }
</style>